import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const [isUserLogin, setIsUserLogin] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("LoginData");
    setIsUserLogin(!!storedData);
  }, []);

  if (isUserLogin === null) {
    return <div>Loading...</div>;
  }

  if (!isUserLogin) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
